export const MAX_LOGIN_ATTEMPTS_ALLOWED = 4;
export const MIN_RECAPTCHA_SCORE = 0.5;
